import { Modal, message } from 'antd';
import cccApi, { CccWorkspaceKind, CccWorkspaceSearchMatch } from '../api/cccApi';

export async function fetchCccWorkspaceSearch(
  workspace: CccWorkspaceKind,
  query: string
): Promise<CccWorkspaceSearchMatch[]> {
  const q = query.trim();
  if (q.length < 2) {
    message.warning('Introduza pelo menos 2 caracteres para pesquisar.');
    return [];
  }

  const hide = message.loading('A pesquisar em toda a equipa e em todos os estados…', 0);
  try {
    const res = await cccApi.searchWorkspace(workspace, q);
    if (!res.success) {
      throw new Error(res.message || 'Não foi possível concluir a pesquisa.');
    }
    return Array.isArray(res.matches) ? res.matches : [];
  } finally {
    hide();
  }
}

export function showCccSearchNotFound(query: string) {
  Modal.info({
    title: 'Nenhum resultado',
    content: `Não foi encontrado nenhum cliente para «${query}» em Recuperação ou Prospeção (nome de empresa, contacto ou NIF).`,
    okText: 'Fechar',
    centered: true,
  });
}

function workspaceAreaLabel(workspace: CccWorkspaceKind): string {
  if (workspace === 'prospeccao') return 'Prospeção';
  if (workspace === 'recuperacao') return 'Recuperação';
  if (workspace === 'retencao') return 'Reposição';
  return workspace;
}

export function showCccSearchSuccess(match: CccWorkspaceSearchMatch) {
  const area = workspaceAreaLabel(match.workspace);
  const iniciadoPor = match.is_available
    ? 'Ninguém (na Pool — ainda não iniciada)'
    : match.owner_user_name?.trim() ||
      (match.owner_user_id ? `Utilizador #${match.owner_user_id}` : 'Desconhecido');

  Modal.info({
    title: 'Cliente encontrado',
    content: `Área: ${area}\nEmpresa: ${match.label}\nIniciado por: ${iniciadoPor}`,
    okText: 'Continuar',
    centered: true,
  });
}

export function canNavigateToMatch(
  match: CccWorkspaceSearchMatch,
  opts: { canManageWorkspaceScope: boolean; currentUserId: number | null }
): { ok: true } | { ok: false; reason: string } {
  if (match.is_available) {
    return { ok: true };
  }
  const ownerId = match.owner_user_id;
  if (!ownerId) {
    return { ok: true };
  }
  if (opts.canManageWorkspaceScope) {
    return { ok: true };
  }
  if (opts.currentUserId && ownerId === opts.currentUserId) {
    return { ok: true };
  }
  const who = match.owner_user_name || `utilizador #${ownerId}`;
  return {
    ok: false,
    reason: `Este cliente está na área de trabalho de ${who}. Peça a um gerente para abrir o registo.`,
  };
}
